import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatTppBalanceAmount, formatTppBalanceLabel } from './tppUiShared';

type SettingsLike = {
  displayPrefix?: string | null;
  displaySuffix?: string | null;
  fractionDigits?: number | null;
} | null | undefined;

/** プール設定から残高／履歴金額表示を作る */
export function useTppMoneyFormat(settings: SettingsLike) {
  const { t } = useTranslation();
  return useMemo(() => {
    const prefix = (settings?.displayPrefix ?? '').trim();
    const suffixRaw = (settings?.displaySuffix ?? '').trim();
    const suffix = prefix || suffixRaw ? suffixRaw : t('tpp.yen');
    const fractionDigits = Math.min(18, Math.max(0, Math.trunc(settings?.fractionDigits ?? 0)));
    return {
      prefix,
      suffix,
      fractionDigits,
      money: (n: number) => formatTppBalanceLabel(n, prefix, suffix, fractionDigits),
      formatAbsAmount: (n: number) => formatTppBalanceAmount(Math.abs(n), fractionDigits),
      zeroBalanceLabel: `${prefix}${formatTppBalanceAmount(0, fractionDigits)}${suffix}`,
    };
  }, [settings?.displayPrefix, settings?.displaySuffix, settings?.fractionDigits, t]);
}
